import { render, staticRenderFns } from "./projectZjIndex.vue?vue&type=template&id=8a0de8b2&"
import script from "./projectZjIndex.vue?vue&type=script&lang=js&"
export * from "./projectZjIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports